﻿window.cBuilderEmailWidgetMarge = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetmarge'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Marge</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter un widget d'espace entre des widgets")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetmarge'>")
        $("<!-- DEBUT MARGE -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(option.element)

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        $("<div class='marge' style='height:15px;'/>").appendTo($Td)
        $Td.attr("jsoncssdatawidget", JSON.stringify("{}"))
        $("<!-- FIN MARGE -->").appendTo(option.element)
    }

    this.nom = "Marge"
    this.icone = "fas fa-grip-lines"

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Hauteur marge:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxSlider({
            min: 5,
            max: 200,
            value: parseInt(option.parent.mGetBodyWidget().find(".marge").css("height").replace("px","")),
            onValueChanged: function (e) {
                option.parent.mGetBodyWidget().find(".marge").css("height",e.value + "px")
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}px`;
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) {
                window.setTimeout(function () { e.component.repaint() }, 0)
            }
        }).dxSlider("instance")
    }

    this.mRemoveStyle = function () {

    }

    this.mUpdateCss = function () {

    }

}